import React from 'react';
import { setLocalData } from '../../utils/util';
import Attention from './Attention';
import axios from 'axios'; // 确保已经安装 axios
import { xauthApi } from '../../constants/constants'; // 确保路径正确
import SelectSubject from './SelectSubject';

const VERSION = process.env.PRODUCT_VERSION;
window.VERSION = VERSION;

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isWeixin: false,
            isLoading: true,
            isAuthorized: false,
        };
    }

    componentDidMount() {
        if (this.isWeixinBrowser()) {
            this.setState({ isWeixin: true });
            this.requestAgain();
        } else {
            alert('请在微信中打开哦～');
            this.setState({ isWeixin: false, isLoading: false });
        }
    }

    requestAgain=()=>{
        let url = xauthApi+'/xauth/api/self/user/profile?login_type=weixin&wxc=xuanke';
        let logoutUrl =xauthApi+'/xauth/api/user/logout';
        let attentionUrl = '';
        if (window.location.origin == 'https://xk.shijieu.cn') {
            attentionUrl='https://xk.shijieu.cn/attention';
        } else {
            attentionUrl='http://xk.t.shijieu.cn/attention';
        }
        let that = this;
        // localStorage.removeItem('share');
        $.ajax({
            url: url,
            dataType: "json",
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true,
            success: function (result) {
                if (result.code == 302) {
                    window.location = result.data.xauth_redirect;
                } else if (result.code == 200) {
                    if(result.data.subscribe==0){//未关注
                        alert('提示：您还未关注公众号');
                        localStorage.removeItem('share');
                        axios.get(logoutUrl).then(out=>{//退出
                            window.location.href=attentionUrl;
                        });
                    } else {
                        // 成功进入的埋点
                        var userId = result.data.id; // 替换为你生成的用户ID
                        window.gtag('config', 'G-FKF7E7QZ8V', {
                            'user_id': userId
                        });
                        window.gtag('event', '访问首页', {
                            'send_to': 'G-FKF7E7QZ8V',
                            // 'used_id': userId
                        });
                        setLocalData('user_detail', result.data);
                        that.setState({
                            isFirst:true,
                            loading: false,
                            isAuthorized: true,
                            isLoading: false
                        })
                    }
                }else {
                    that.requestAgain();
                }
            },
            error:function () {
                that.requestAgain();
            }
        });

    };

    isWeixinBrowser = () => {
        const ua = window.navigator.userAgent.toLowerCase();
        return /micromessenger/.test(ua);
    }


    render() {
        const { isWeixin, isLoading, isAuthorized } = this.state;
        if (isLoading) {
            return <div>Loading...</div>;
        }

        if (!isWeixin) {
            return (
                <div style={{ height: '100%', width: '100%', position: 'relative' }}>
                    <Attention />
                </div>
            );
        }

        if (isWeixin && !isAuthorized) {
            return <div>微信授权中...</div>;
        }

        return (
            <div style={{ height: '100%', width: '100%', position: 'relative' }}>
                {/* <div>微信授权成功</div> */}
                <SelectSubject />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/SelectSubject/index.js